export default class AbortError extends Error {
  constructor(message = "Abort error") {
    super(message);
    this.name = "AbortError";
  }
}

export function isAbortError(error: unknown) {
  return (
    error instanceof AbortError ||
    (error &&
      typeof error === "object" &&
      "name" in error &&
      error.name === "AbortError")
  );
}
